import { Star } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import {
  type CustomTriggerChildren,
  Tooltip,
} from "@tokenterminal/core/ui/overlays/tooltip/Tooltip"
import Link from "next/link"
import { iconsBySlug } from "../market-sectors/constants"
import { useMarketSector } from "../market-sectors/hooks/useMarketSector"

interface MarketSector {
  slug: string
  name: string
}

interface MarketSectorTooltipProps {
  marketSector: MarketSector
  children: CustomTriggerChildren
}

export const MarketSectorTooltip = ({
  marketSector,
  children,
}: MarketSectorTooltipProps) => {
  const { data: marketSectorData, isLoading } = useMarketSector(
    marketSector.slug
  )

  return (
    <Tooltip
      content={
        <div className="flex gap-2.5 p-2.5 font-normal">
          <div className="bg-neutral-300/30 dark:bg-neutral-700/50 rounded w-5 h-5 flex items-center justify-center flex-shrink-0">
            <Icon
              as={iconsBySlug[marketSector.slug] || Star}
              className="w-3 h-3 text-fg-secondary"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <div className="flex flex-col">
              <div className="text-[13px] pt-px font-medium">
                {marketSector.name}
              </div>
              <div className="text-xs text-fg-secondary">
                {Math.floor(Math.random() * 50) + 10} projects
              </div>
            </div>
            {marketSectorData?.data?.description?.what && (
              <div className="text-xs text-fg-secondary line-clamp-3 max-w-[300px]">
                {marketSectorData?.data?.description?.what}
              </div>
            )}
            <Link
              href={`/markets/${marketSector.slug}`}
              className="text-xs text-fg-blue hover:underline"
            >
              Learn more
            </Link>
          </div>
        </div>
      }
      tooltipProps={{
        className: "rounded-lg p-0",
        placement: "right",
      }}
    >
      <Tooltip.Trigger>{children}</Tooltip.Trigger>
    </Tooltip>
  )
}
